module.exports = __webpack_public_path__ + "img/fingerprint.29c01d67.svg";